export default __webpack_public_path__ + "static/media/vendor-spiker2.ea44b9b8.jpg";